import React from "react";
import { useSelector } from "react-redux";
import { Depots } from "./depots";
import { DepotsPersonal } from "./depotPersonal/index";
import ClientsProjectsTab from "./clientsProjects/index";
import { ProjectManagers } from "./projectManager/index";

const AdminMenuList = () => {

  /** redux store useDispatch & useSelector ------------------------------ **/
  const state = useSelector((state) => state.depotUsers);
  const { signoutModelOpenFlag } = useSelector((state) => state.auth);
  
   /** variable declarations ----------------------------------------------------- **/
  const selectedTabValue = state.selectedTab && state.selectedTab || 'DEPOTS';

  let componentObject = {
    "DEPOTS": <Depots />,
    "DEPOTS PERSONNEL": <DepotsPersonal />,
    "CLIENTS/PROJECTS": <ClientsProjectsTab />,
    "PROJECT MANAGERS": <ProjectManagers />,
  }

  return (
    <>
      <div className={`main-admin-tab-div d-flex flex-column ms-3 me-3 ${signoutModelOpenFlag == true ? "add-overlay-for-depot-dropdown" : ""}`}>
        {componentObject[`${selectedTabValue}`]}
      </div>
    </>
  );
};

export default AdminMenuList;
